export function getProcedureVersionFromTaskInstance(task, procedureHashid) {
    var assignedContent = task.assigned_version_content;
    // it the assigned version was deleted. we just stop here.
    if (assignedContent == null) {
        return null;
    }
    if (assignedContent.content_type === 'processversion') {
        for (var _i = 0, _a = assignedContent.content; _i < _a.length; _i++) {
            var p = _a[_i];
            if (p.type === 'processprocedure' && p.id === procedureHashid) {
                if (p.deleted) {
                    throw Error("getProcedureVersionFromTaskInstance: Procedure deleted: ".concat(procedureHashid));
                }
                return p;
            }
        }
    }
    else if (procedureHashid === assignedContent.hashid) {
        return assignedContent;
    }
    throw Error("getProcedureVersionFromTaskInstance: Invalid procedureHashid: ".concat(procedureHashid));
}
